require('./retailLoanFullImageModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const OKModal = require('components/commons/OKModal/OKModal');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
// @constants
const {
    RETAIL_LOAN_FULL_IMAGE_SIZE_ADJUSTMENT,
} = require('../../../../loansConstants/index');

class RetailLoanFullImageModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            viewerSize: 'auto'
        }

        this.buildImage = this.buildImage.bind(this);
        this.getSize = this.getSize.bind(this);
    }

    getSize(viewerSize) {
        this.setState({ viewerSize });
    }

    buildImage() {
        const { urlImage } = this.props;
        const { viewerSize } = this.state;
        const size = viewerSize - RETAIL_LOAN_FULL_IMAGE_SIZE_ADJUSTMENT; // to avoid vertical scroll

        return (
            <div className="retail-loan-full-image-modal__image-container">
                <img src={urlImage} style={{ width: size, height: size }} />
            </div>
        );
    }

    render() {
        const { showModal, onHandleToggleModal } = this.props;

        const backButtonText = toFirstUppercase(formatText('buttonsActions-goBack'));
        const image = this.buildImage();

        return (
            <OKModal
                isOpen={showModal}
                onCloseCallback={onHandleToggleModal}
                onSecondaryButtonClick={onHandleToggleModal}
                shouldCloseOnOverlayClick
                content={image}
                getSize={this.getSize}
                size="large"
                footerType="navigation"
                secondaryButtonText={backButtonText}
                hideHeader
            />
        )
    }
}

RetailLoanFullImageModal.propTypes = {
    urlImage: PropTypes.string.isRequired,
    showModal: PropTypes.bool,
    onHandleToggleModal: PropTypes.func.isRequired
};

module.exports = RetailLoanFullImageModal;
